








































































































































import Vue from 'vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import CreateProjectAddressSearch from '@/components/project/CreateProjectAddressSearch.vue'
import NumberField from '@/components/NumberField.vue'

interface ComponentData {
  loading: boolean
  isEdit: boolean
  showSearchDialog: boolean

  addressId: number | null
  address: string | null
  employeeFrom: number | null
  employeeTo: number | null
  menu1: boolean
  menu2: boolean
  dateFromFormatted: string | null
  dateToFormatted: string | null
  dateFrom: string | null
  dateTo: string | null
  dateRules: any[]
  amount: number | null
  belegNumber: string | null
}

export default Vue.extend({
  name: 'GanttDetailDialog',

  components: {
    CreateProjectAddressSearch,
    NumberField
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: Object as () => any,
    employeeList: Array as () => any[]
  },

  data (): ComponentData {
    return {
      loading: false,
      isEdit: true,
      showSearchDialog: false,

      addressId: null,
      address: null,
      employeeFrom: null,
      employeeTo: null,
      menu1: false,
      menu2: false,
      dateFromFormatted: null,
      dateToFormatted: null,
      dateFrom: null,
      dateTo: null,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        },
      ],
      amount: null,
      belegNumber: null
    }
  },

  watch: {
    dateFromFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateFrom = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
      } else {
        this.dateFrom = null
      }
    },

    dateToFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateTo = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
      } else {
        this.dateTo = null
      }
    },
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    onSearchAddressClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
      setTimeout(() => {
        const focusedField: any = this.$refs['secondFocusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onSelectedAddress (data: SearchAddress): void {
      this.closeSearchDialog()
      this.address = data.genAdresse
      this.addressId = data.id
    },

    selectedAddressEmployee (data: SearchAddressEmployee): void {
      this.closeSearchDialog()
      this.address = data.genAdresse
      this.addressId = data.adressID
    },

    onDateFromChange (date: string): void {
      this.dateFromFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateFromBlur (): void {
      this.dateFromFormatted = this.dateFrom && moment(this.dateFrom).isValid() ? moment(this.dateFrom).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onDateToChange (date: string): void {
      this.dateToFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateToBlur (): void {
      this.dateToFormatted = this.dateTo && moment(this.dateTo).isValid() ? moment(this.dateTo).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onAmountChange (): void {
      if(this.amount == null || this.amount < 0) {
        this.amount = 0
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      //console.log('save')
    },

    onDeleteButtonClick (): void {
      //console.log('delete')
    },

  },

  async mounted (): Promise<void> {
    this.addressId = this.dialogData.addressId
    this.address = this.dialogData.genAdresse
    this.dateFrom = this.dialogData.start
    this.dateFromFormatted = this.dialogData.end && moment(this.dialogData.start).isValid() ? moment(this.dialogData.start).format('DD.MM.YYYY') : ''
    this.dateTo = this.dialogData.end
    this.dateToFormatted = this.dialogData.end && moment(this.dialogData.end).isValid() ? moment(this.dialogData.end).format('DD.MM.YYYY') : ''
    this.employeeFrom = this.dialogData.employeeFrom
    this.employeeTo = this.dialogData.employeeTo
    this.amount = this.dialogData.amount
    this.belegNumber = this.dialogData.belegNumber

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
